<template>
     <div class="defaultrulepropertie-admin">
        <b-form  v-show="mode === 'save' || mode === 'remove' || mode === 'read'">
             <input id="defaultrulepropertie-id" type="hidden" v-model="defaultrulepropertie.id" />
             <b-row>
                <b-col md="6" sm="12">
                    <b-form-group 
                        label="Description:" 
                        label-for="defaultrulepropertie-default_rule_property_name">
                        <b-form-input id="defaultrulepropertie-default_rule_property_name" 
                            type="text" 
                            v-model="defaultrulepropertie.default_rule_property_name" required
                            size="sm"
                            :readonly="mode === 'remove' || mode === 'read' || mode === 'insert'"
                            placeholder="Description..." />
                    </b-form-group>
                </b-col>
             </b-row>  
         </b-form>
                <b-row>                   
                <b-col xs="12">
                    <b-button  
                        title="Add" 
                        size="sm" 
                        class="mt-2 mb-2 fa fa-plus" 
                        variant="dark" 
                        v-show="mode !== 'save' && mode !== 'remove'"
                        @click="alterModo"></b-button>
                    <b-button  
                        title="Save"  
                        size="sm" 
                        variant="dark" 
                        class="mt-2 mb-2 ml-2 fa fa-save" 
                        v-if="mode === 'save'"
                        @click="save"></b-button>
                    <b-button  
                        title="Remove" 
                        size="sm" 
                        variant="dark" 
                        class="mt-2 mb-2 ml-2 fa fa-trash" 
                        v-if="mode === 'remove'"
                        @click="remove"></b-button>
                    <b-button  
                        title="Back" 
                        size="sm" 
                        variant="dark" 
                        class="mt-2 mb-2 ml-2 fa fa-ban"  
                        v-if="mode === 'remove' || mode === 'save' || mode === 'read' "
                        @click="reset"></b-button>
                    <b-button  
                    size="sm" 
                    title="Search" 
                    class="mt-2 mb-2 ml-2 fa fa-search" 
                    @click="[loadBusinesss(),toggleBusy(),showTable = !showTable]" 
                    variant="dark" 
                    v-show="mode !== 'save' && mode !== 'remove'"
                    >
                    </b-button>
                </b-col>
            </b-row>
            <b-row v-show="mode !== 'save' && mode !== 'remove'">
                <div class="col-sm-6">
                    <b-form-group> 
                    <input size="lg" type="text" icon="search" v-model="search" placeholder="Search for description" class="form-control">                  
                    </b-form-group>
                </div>
            <transition  name="slide" type="animation" appear>       
                <b-table 
                        :busy="isBusy"  
                        class="table-responsive" 
                        hover 
                        key="slide"  
                        head-variant="light" 
                        :per-page="perPage" 
                        :current-page="currentPage" 
                        :items="filteredList" 
                        :fields="fields">
                     <template v-slot:table-busy>
                        <div class="text-center text-info my-2">
                            <b-spinner class="align-middle"></b-spinner>
                            <strong>Loading...</strong>
                        </div>
                    </template>
                    <template v-slot:cell(actions)="data">
                        <b-button 
                                title="View" 
                                size="sm" 
                                variant="light" 
                                @click="loadBusiness(data.item, 'read')" 
                                class="mr-2 mt-2">
                            <i class="fa fa-drivers-license-o"></i>
                        </b-button>
                        <b-button 
                            title="Edit" 
                            size="sm" 
                            variant="light" 
                            @click="loadBusiness(data.item)" class="mr-2 mt-2">
                            <i class="fa fa-pencil"></i>
                        </b-button>
                        <b-button 
                            title="Remove" 
                            size="sm" 
                            variant="light" 
                            @click="loadBusiness(data.item, 'remove')" 
                            class="mr-2 mt-2">
                            <i class="fa fa-trash"></i>
                        </b-button>
                    </template>
                </b-table>
            </transition>
            <b-pagination 
              v-model="currentPage" 
              :per-page="perPage"
              :total-rows="rows">
              </b-pagination> 
            </b-row>
      </div>
</template>

<script>
import { baseApiUrl, showError } from '@/global'
import axios from 'axios'

export default {
         name: 'DefaultRulePropertie',
                data: function() {
                return {
                    mode: 'insert',
                    search: '',
                    defaultrulepropertie: {},
                    defaultruleproperties: [],
                    showTable: false,
                    showSearch: true,
                    isBusy: false,
                    currentPage: 1,
                    perPage: 5,
                    fields: [
                        { key: 'default_rule_property_name', label: 'Description', sortable: true },
                        { key: 'actions', label: 'Ações', variant: 'secondary' }
                    ]
                }
            },
            computed: {
                user(){
                    return this.$store.state.user
                },
                compan(){
                    return this.$store.state.compan
                },
                filteredList() {
                return this.defaultruleproperties.filter(defaultrulepropertie => {
                return defaultrulepropertie.default_rule_property_name.toLowerCase().includes(this.search.toLowerCase())
                    })
                },
                icon() {
                    return this.showTable ? "fa-retweet" : "fa-search"
                },
                 rows() {
                    return this.defaultruleproperties.length
                }
            },
            methods: {
            toggleBusy() {
                this.isBusy = !this.isBusy
            },
            loadBusinesss() {
                const url = `${baseApiUrl}/defaultrulepropertiebycompany/${this.compan.id}`
                axios.get(url).then(res => {
                    this.defaultruleproperties = res.data
                     this.isBusy = false
            })
            },
            reset() {
                this.mode = 'insert'
                this.loadBusinesss()
            },
            alterModo() {
                        this.mode = 'save'
                        this.defaultrulepropertie = {}
                        this.$refs.searchFocus.focus();
                },
            save() {
                const method = this.defaultrulepropertie.id ? 'put' : 'post'
                const id = this.defaultrulepropertie.id ? `/${this.defaultrulepropertie.id}` : ''
                this.defaultrulepropertie.default_rule_property_company_id = this.compan.id    
  
                axios[method](`${baseApiUrl}/defaultruleproperties${id}`, this.defaultrulepropertie)
                    .then(() => {
                        this.$toasted.global.defaultSuccess()
                        this.reset()
                    })
                    .catch(showError)
            },
            remove() {
                const id = this.defaultrulepropertie.id
                axios.delete(`${baseApiUrl}/defaultruleproperties/${id}`)
                    .then(() => {
                    this.$toasted.global.defaultSuccess()
                    this.reset()
                    })
                    .catch(showError)
            },
            loadBusiness(defaultrulepropertie, mode = 'save') {
                this.mode = mode
                this.defaultrulepropertie = { ...defaultrulepropertie }
                this.$refs.searchFocus.focus();
            }
                
             },
            mounted() {
                this.showTable = true
            }
    }       
</script>

<style>

    

 .defaultrulepropertie-admin label{
        font-size: 0.75rem;
           color: black;
    }
    .defaultrulepropertie-admin select{
        font-size: 0.75rem;
    }
    .defaultrulepropertie-admin input{
        font-size: 0.75rem;
    }
    .defaultrulepropertie-admin textarea{
        font-size: 0.75rem;
    }
    .defaultrulepropertie-admin button{
        font-size: 0.75rem;
    }
    .defaultrulepropertie-admin table{
        font-size: 0.75rem;
    }

    @keyframes slide-in {
    from {transform: translateY(40px);}
    to {transform: translateY(0);}
    }

    @keyframes slide-out {
        from {transform: translateY(0);}
        to {transform: translateY(40px);}
    }

    .slide-enter-active {
    animation: slide-in 1s ease;
        transition: opacity 1s;
    }

    .slide-leave-active {
        animation: slide-out 1s ease;
        transition: opacity 1s;
    }

    .slide-enter, .slide-leave-to{
        opacity: 0;
    }

    .fade-enter, .fade-leave-to{
    opacity: 0;
    }

    .fade-enter-active, .fade-leave-active{
    transition: opacity 1s;
    }

</style>
